import { Component, inject } from "@angular/core";
import { tap } from "rxjs";
import { ButtonComponent } from "../../../../shared/components/button/button.component";
import { getParams } from "../../../../utils/utils";
import { EventsManagementService } from "../../../services/events-management.service";
import { ValidatedReportsSectionComponent } from "./validated-reports-section/validated-reports-section.component";
import { CheckInSectionComponent } from "./check-in-section/check-in-section.component";

@Component({
  selector: "app-validated-summary-tab",
  imports: [
    ButtonComponent,
    ValidatedReportsSectionComponent,
    CheckInSectionComponent,
  ],
  templateUrl: "./validated-summary-tab.component.html",
  styleUrl: "./validated-summary-tab.component.scss",
})
export class ValidatedSummaryTabComponent {
  private readonly _eventService = inject(EventsManagementService);
  eventId: number | null = null;

  private eventId$ = getParams("id").pipe(tap((id) => (this.eventId = id)));

  constructor() {
    this.eventId$.subscribe();
  }

  downloadReport() {
    if (!this.eventId) {
      return;
    }

    this._eventService.downloadTicketScansReport(this.eventId).subscribe({
      next: (blob) => {
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "relatorio_leituras.pdf";
        a.click();
        URL.revokeObjectURL(url);
      },
      error: (error) => {
        console.error("Error downloading report:", error);
      },
    });
  }
}
